import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { accountService } from "../../services/enhancedCrudService";
import { useState, useEffect } from "react";

const Header = () => {
  const navigate = useNavigate();
  const refreshToken = sessionStorage.getItem("refreshToken");
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
    // Toggle body class for sidebar state
    document.body.classList.toggle('sidebar-open', !sidebarOpen);
  };

  // Handle clicking outside sidebar to close it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarOpen && !event.target.closest('.sidebar') && !event.target.closest('.mobile_btn')) {
        setSidebarOpen(false);
        document.body.classList.remove('sidebar-open');
      }
    };

    // Handle clicking on overlay to close sidebar
    const handleOverlayClick = (event) => {
      if (event.target === document.body && sidebarOpen) {
        setSidebarOpen(false);
        document.body.classList.remove('sidebar-open');
      }
    };

    if (sidebarOpen) {
      document.addEventListener('click', handleClickOutside);
      document.addEventListener('click', handleOverlayClick);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
      document.removeEventListener('click', handleOverlayClick);
    };
  }, [sidebarOpen]);

  const logout = async (e) => {
    e.preventDefault();
    console.log("Logout function triggered");

    if (!refreshToken) {
      console.warn("No refresh token found in sessionStorage.");
      toast.warning("Session expired. Please login again.");
      sessionStorage.clear();
      navigate("/", { replace: true });
      return;
    }

    try {
      console.log("Calling logout API with refreshToken:", refreshToken);
      await accountService.logout({ refresh_token: refreshToken });
      sessionStorage.clear();
      toast.success("Logged out successfully.");
      navigate("/", { replace: true });
    } catch (error) {
      console.error("Logout error:", error);
      toast.error("Logout failed. Try again.");
    }
  };

  return (
    <div className="header header-one hidden-print">
      <a className="mobile_btn" id="mobile_btn" onClick={toggleSidebar}>
        <i className="fas fa-bars"></i>
      </a>
      <ul className="nav nav-tabs user-menu">
        <li className="nav-item dropdown">
          <div className="subscription-logout">
            <ul>
              <li>
                <a onClick={logout} href="#" style={{ cursor: "pointer" }}>
                  <img
                    src="/assets/img/power.png"
                    alt="Logout"
                    style={{ maxWidth: "100%", height: "25px" }}
                  />
                </a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default Header;
